import { SystemStyleObject } from '@chakra-ui/styled-system';

const listWrapperSx: SystemStyleObject = {
  '& .rdg .rdg-header-row .rdg-cell': {
    border: 'none',
    fontWeight: 600,
  },
};

const checkboxSx: SystemStyleObject = {
  '.chakra-checkbox__control': {
    opacity: 1,
    _checked: {
      _disabled: {
        bg: 'textSubdued',
        borderColor: 'textSubdued',
        opacity: 0.4,
      },
    },
  },
};

export const suggestedCollaboratorsListSx = {
  listWrapperSx,
  checkboxSx,
};
